// extracted by mini-css-extract-plugin
export var button = "_r-0";
export var buttonContent = "_r-e";
export var buttonGroup = "_r-c";
export var dontRestrainIconWidth = "_r-a";
export var dropdownButton = "_r-b";
export var iconContainer = "_r-9";
export var lg = "_r-4";
export var md = "_r-3";
export var pending = "_r-f";
export var sm = "_r-2";
export var spinner = "_r-d";
export var squared = "_r-8";
export var wrapText = "_r-g";
export var xl = "_r-5";
export var xs = "_r-1";
export var xxl = "_r-6";
export var xxxl = "_r-7";